<fv-modal #changeDelivered [size]="FV_MODAL_SIZE.sm" [modalPosition]="FV_MODAL_POSITION.center" [hasDividers]="false"
  [opaqueBackground]="false" [isBackgroundCloseModal]="true" [showIconClose]="false" [closeModalOnPanDown]="true"
  [isHeaderHidden]="true" [headerPosition]="FV_MODAL_HEADER_POSITION.end">
  <div body>
    <div class="flex flex-col justify-center items-center gap-4 mb-8">
      <span class="text-4xl md:!text-5xl font-semibold text-white">{{ 'global.change' | translate}}</span>
      <span class="text-7xl md:!text-7xl  font-semibold text-blue-300">{{paymentResume?.changeDelivered | currency:
        currency :
        'symbol'}}</span>
    </div>
  </div>
</fv-modal>
